export default "__VITE_ASSET__WlBgwSss__"